import { KonvaEventObject } from 'konva/lib/Node';
//

export enum CursorTypes {
  Default = 'default',
  Crosshair = 'crosshair',
  Grab = '-webkit-grab',
  Grabbing = 'grabbing',
  ColResize = 'col-resize',
  RowResize = 'row-resize',
  Pointer = 'pointer',
  Text = 'text',
}

export type UseKonvaCursor = {
  onMouseEnter: (
    e: KonvaEventObject<MouseEvent>,
    cursorShape?: CursorTypes
  ) => void;
  onMouseLeave: (
    e: KonvaEventObject<MouseEvent>,
    defaultCurShape?: CursorTypes
  ) => void;
};

const useKonvaCursor = (): UseKonvaCursor => {
  const onMouseEnter = (
    e: KonvaEventObject<MouseEvent>,
    cursorShape = CursorTypes.Pointer
  ) => {
    const container = e?.target?.getStage()?.container();
    if (container) container.style.cursor = cursorShape;
  };

  const onMouseLeave = (
    e: KonvaEventObject<MouseEvent>,
    defaultCurShape?: CursorTypes
  ) => {
    const container = e?.target?.getStage()?.container();
    if (container) container.style.cursor = defaultCurShape ?? 'default';
  };

  return {
    onMouseEnter,
    onMouseLeave,
  };
};

export default useKonvaCursor;
